<template>

    <header class="header">

        <div class="header__bloc-top">

            <a href="/">
                <img :src="computedLogo" class="header__bloc-top__logo">
            </a>

            <div>

                <a v-if="showLoginAction" class="header__bloc-top__link-use" href="/magic-request-email">{{ $t('your_data_CTA_already_used_CF') }}</a>

                <a v-if="showLoginAction" class="header__bloc-top__link-login" href="/login/email">{{ $t('your_data_CTA_sign_in') }}</a>

            </div>


        </div>

        <div class="header__page"></div>

    </header>

</template>

<script>

import Storage from '@/helpers/storage'

export default {

    name: 'header-green',

    computed: {

        showLoginAction () {
            return this.isDesktop && !Storage.getItem('token')
        },

        isDesktop() {
            return this.$mq === 'lg'
        },

        computedLogo() {
            return this.isDesktop ? '/img/logo/large/white.svg' : '/img/logo/fox/green-head-white.svg'
        }

    },

    methods: {

        goLanding() {

            this.$router.push({path: '/'})
        }
    }
}

</script>

<style scoped lang="scss">


    .header {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        padding: 8px 16px;
        box-shadow: 0 1px 0 0 rgba(17, 17, 26, 0.1);
        background-color: $forest;
        @media screen and (min-width: $above-tablet-length) {
            box-shadow: none;
            padding: 20px 64px;
        }
        &__bloc-top {
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            &__logo {
                width: 40px;
                object-fit: contain;
                @media screen and (min-width: $above-tablet-length) {
                    width: 149px;
                }
            }

            &__link-login {
                cursor: pointer;
                padding: 8px 16px;
                background-color: $rifle;
                font-size: 16px;
                font-weight: bold;
                line-height: 1.31;
                color: $white;
                border-radius: 40px;
                margin-left: 16px;
            }

            &__link-use {
                cursor: pointer;
                font-size: 17px;
                font-weight: bold;
                line-height: 1.24;
                color: $white;
                text-decoration: underline;
            }
        }

        &__page {

        }
    }

</style>
